import React, { useState } from 'react';
import { IconLock } from './Icons';

export default function LeadModal({ isOpen, onClose, onSubmit }) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !phone) {
      alert('Please enter email and phone number.');
      return;
    }
    setBusy(true);
    await onSubmit({ email, phone });
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="absolute inset-0 bg-ink/50" onClick={onClose} aria-hidden />
      <div className="relative z-10 w-full sm:max-w-md bg-white border-2 border-forest shadow-stamp p-8 sm:rounded-none">
        <div className="w-12 h-12 bg-parchment border-2 border-forest flex items-center justify-center mb-5">
          <IconLock className="w-6 h-6 text-forest" />
        </div>
        <h3 className="font-serif text-2xl text-forest font-semibold">Contact for checkout</h3>
        <p className="text-sm text-ink/60 mt-2 leading-relaxed">
          Enter your details to proceed to secure payment. We use this only to deliver your report.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="field-label">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="field-input"
            />
          </div>
          <div>
            <label className="field-label">Mobile</label>
            <input
              type="tel"
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="10-digit number"
              className="field-input"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60">
            {busy ? 'Please wait…' : 'Continue to payment'}
          </button>
          <button type="button" onClick={onClose} className="w-full text-sm font-semibold text-ink/50 py-2 hover:text-ink">
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
}
